import React from 'react';
import Describe from '../Describe';
import { ContainerContent, Section } from './styles';

export interface Props {
  children: JSX.Element | JSX.Element[];
  title: string;
  describeTitle: string | JSX.Element;
}

const Box = (
  { children, title, describeTitle }: Props,
  ref: React.Ref<HTMLElement>,
) => {
  return (
    <Section ref={ref}>
      <Describe title={title} describeTitle={describeTitle} />
      <ContainerContent>{children}</ContainerContent>
    </Section>
  );
};

export default React.forwardRef(Box);
